import React from 'react';
import styles from './Canvasses.module.css';

const StakeholderList = ({ stakeholders, onSelect, selectedStakeholderId, userCompanies }) => {
  if (stakeholders.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>No stakeholders found</p>
        <small>Create stakeholders for your companies to see them here.</small>
      </div>
    );
  }

  return (
    <div className={styles.stakeholderList}>
      {stakeholders.map(stakeholder => {
        const company = userCompanies.find(c => c.id === stakeholder.parentCompanyId);
        return (
          <div 
            key={stakeholder.id} 
            className={`${styles.stakeholderItem} ${selectedStakeholderId === stakeholder.id ? styles.selectedItem : ''}`}
            onClick={() => onSelect(stakeholder)}
          >
            <div className={styles.stakeholderName}>
              <strong>{stakeholder.name}</strong>
              {stakeholder.objective && (
                <span className={styles.stakeholderObjective}>
                  {stakeholder.objective}
                </span>
              )}
              <span className={styles.stakeholderType}>
                {stakeholder.metadata?.stakeholderType || 'Stakeholder'}
              </span>
              <span className={styles.stakeholderCompany}>
                {company?.name || 'Unknown Company'}
              </span>
              <span className={`${styles.categoryBadge} ${stakeholder.isInternal ? styles.internalCategory : styles.externalCategory}`}>
                {stakeholder.isInternal ? 'Internal' : 'External'}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StakeholderList;
